import { createSlice } from '@reduxjs/toolkit';




import { MANAGE_ASSESSOR } from '../../actions/ManageAssessor/ManageAssessorActionType';


const initialState = {
  manageAssessorCycles: {
    isLoading: false,
        
    assessmentCycles: [],
    searchData: null,
    data:null,
    errors: '',
    searchError: '',
    message: ''
  }
};

export const manageAssessorCyclesSlice = createSlice({
  name: MANAGE_ASSESSOR,
  initialState,
  reducers: {
    getManageAssessorAction: (state) => {
      state.manageAssessorCycles.isLoading = true;
      state.manageAssessorCycles.errors = '';
    },
    getManageAssessorSuccessAction: (state, action) => {

      if (action.payload) {
        state.manageAssessorCycles.assessmentCycles = action.payload;
      
      }
      state.manageAssessorCycles.errors = '';
      state.manageAssessorCycles.isLoading = false;
    },
    getManageAssessorFailureAction: (state, action) => {
      // state.user.isLoading = false;
      state.manageAssessorCycles.isLoading = false;
      state.manageAssessorCycles.errors = action.payload;
    },
 
 
    setManageAssessorSaveAction: (state) => {
      state.manageAssessorCycles.isLoading = true;
      state.manageAssessorCycles.errors = '';
    },
    setSaveManageAssessorSuccessAction: (state, action) => {
      state.manageAssessorCycles.isLoading = false;
      state.manageAssessorCycles.errors = '';
      const p = action.payload;
      if ((p?.status === 'Success' && (p?.statusCode === 201 || p?.statusCode === 200)) || p?.data === 1) {
        state.manageAssessorCycles.message = 'Saved Successfully!';
      } else {
        state.manageAssessorCycles.errors = p?.message || 'Save did not complete successfully.';
      }
    },
    setSaveManageAssessorFailureAction: (state, action) => {
      state.manageAssessorCycles.isLoading = false;
      state.manageAssessorCycles.errors = action.payload;
    },


    getManageAssessorUpdateAction: (state) => {
      state.manageAssessorCycles.isLoading = true;
      state.manageAssessorCycles.searchError = '';
    },
    getManageAsesorUpdateSuccessAction: (state, action) => {
      if (action.payload) {
        state.manageAssessorCycles.searchData = action.payload;
      } else {
        state.manageAssessorCycles.searchData = null;
      }
      state.manageAssessorCycles.searchError = '';
      state.manageAssessorCycles.isLoading = false;
    },
    getManageAssessorUpdateFailureAction: (state, action) => {
      state.manageAssessorCycles.isLoading = false;
      state.manageAssessorCycles.searchData = null;
      state.manageAssessorCycles.searchError = action.payload;
    },
    clearManageAssessorModalState: (state) => {
      state.manageAssessorCycles.searchError = '';
      state.manageAssessorCycles.searchData = null;
    },

   
  }
});

export const {
    getManageAssessorAction,
    getManageAssessorSuccessAction,
    getManageAssessorFailureAction,
    setManageAssessorSaveAction,
    setSaveManageAssessorSuccessAction,
    setSaveManageAssessorFailureAction,
    getManageAssessorUpdateAction,
    getManageAsesorUpdateSuccessAction,
    getManageAssessorUpdateFailureAction,
    clearManageAssessorModalState,

} = manageAssessorCyclesSlice.actions;

export default manageAssessorCyclesSlice.reducer;
      